import { render, staticRenderFns } from "./PsoriasisJointInvestigationPhase.vue?vue&type=template&id=a2f47e6a&scoped=true&"
import script from "./PsoriasisJointInvestigationPhase.vue?vue&type=script&lang=js&"
export * from "./PsoriasisJointInvestigationPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f47e6a",
  null
  
)

export default component.exports